import React from 'react';
import { Layers, Sparkles, Mic, Usb, Smartphone, Activity } from 'lucide-react';
import { consoleFeatures } from '../data/mock';

const ConsoleFeatures = () => {
  const iconMap = {
    layers: Layers,
    sparkles: Sparkles,
    mic: Mic,
    usb: Usb,
    smartphone: Smartphone,
    activity: Activity
  };

  return (
    <section className="section-padding bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_4f5cf654-3a0c-4d01-a704-3b564425efff/artifacts/12uw8xwa_FACE_WEB_Assets_Highlight-1-Desktop_2024-09-18_Rev.0.jpg"
          alt="WING Console Highlight"
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-gray-900/90 to-gray-900"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Tecnologia de ponta, recursos de gigantes. Agora, nas suas mãos com a WING.
            </h2>
            <p className="text-xl text-yellow-400 font-medium">Conexão e Processamento de sobra da WING</p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {consoleFeatures.features.map((feature, index) => {
              const Icon = iconMap[feature.icon];
              return (
                <div
                  key={index}
                  className="glass p-6 rounded-xl card-hover group"
                >
                  <div className="w-14 h-14 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-yellow-500/20 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-yellow-400" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                  <p className="text-gray-400">{feature.description}</p>
                </div>
              );
            })}
          </div>

          {/* Bottom Info */}
          <div className="mt-16 text-center glass-dark p-8 rounded-2xl">
            <p className="text-gray-300 text-lg mb-4">
              A Console WING é utilizada por profissionais em todo o mundo para eventos,
              igrejas, casas de show e estúdios de gravação.
            </p>
            <p className="text-yellow-400 font-bold text-xl">
              Domine esta tecnologia e destaque-se no mercado!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsoleFeatures;
